import {
    RatingSlider,
    SliderContainer,
} from "../../../PostPoll/PostPollSectionTypes/PostPollRate.styles";
import { LikeThumbComponent } from "../../../PostPoll/PostPollSectionTypes/Rate/BeforeRatingSlider";
import {
    PollTabSectionStack,
    RatePollSliderContainer,
} from "../PollTab.styles";
import { PollSectionTitleTypography } from "../../PostForm.styles";
import React, { useEffect, useState } from "react";
import {
    MAX_RATING,
    MIN_RATING,
} from "../../../PostPoll/PostPollSectionTypes/Rate/PostPollRateSection";
import { TextMarkup } from "@shared/Components/TextMarkup/TextMarkup";
import { Box } from "@mui/material";

export function RateOptionsSection({ content }: { content: string | undefined }) {
    const [value, setValue] = useState(2);

    useEffect(() => {
        const interval = setInterval(() => {
            setValue((prevValue) => {
                if (prevValue >= 8) {
                    clearInterval(interval);
                }

                return prevValue + 0.1;
            });
        }, 50);

        return () => clearInterval(interval);
    }, []);

    return (
        <PollTabSectionStack>
            <PollSectionTitleTypography>Vorschau</PollSectionTitleTypography>
            <RatePollSliderContainer onClick={(e) => e.stopPropagation()}>
                {content && (
                    <Box width="80%" paddingBottom="24px">
                        <TextMarkup
                            sx={{
                                color: "var(--community-color-snow-white)",
                                fontSize: "16px",
                                fontWeight: 700,
                            }}
                            textToMarkup={content}
                        />
                    </Box>
                )}
                <SliderContainer>
                    <RatingSlider
                        max={MAX_RATING}
                        min={MIN_RATING}
                        disableSwap
                        track={false}
                        value={value}
                        slots={{
                            thumb: LikeThumbComponent,
                        }}
                    />
                </SliderContainer>
            </RatePollSliderContainer>
        </PollTabSectionStack>
    );
}
